module.exports = __webpack_public_path__ + "static/media/logo_desarrollo.9ff5011a.png";